<div class="progress-step-spinner-container" [ngClass]="class">
    <div class="progress-step-spinner-section">
        <mat-progress-spinner class="backgroundSpinner" [mode]="mode" [value]="100" [diameter]="68" aria-label="Loading"> </mat-progress-spinner> 
        <mat-progress-spinner class="progressSpinner" [mode]="mode" [value]="currentValue" [color]="color" [diameter]="68" [attr.aria-label]="ariaLabel"> </mat-progress-spinner> 
    </div>
    <div  class="progress-step-spinner-container-text">{{currentStep}}/{{totalSteps}}</div>  
</div>